import jobStatus from "../../../shared/variables/job-status";
import {
  FETCH_GOLFER,
  FETCH_GOLFER_SUCCESS,
  FETCH_GOLFER_FAILED,
} from "../actions";

const initialState = {
  golfer: undefined,
  jobStatus: jobStatus.NOT_STARTED,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case FETCH_GOLFER:
      return {
        ...state,
        jobStatus: jobStatus.PROCESSING,
      };
    case FETCH_GOLFER_SUCCESS:
      return {
        ...state,
        golfer: payload,
        jobStatus: jobStatus.SUCCESS,
      };
    case FETCH_GOLFER_FAILED:
      return {
        ...state,
        jobStatus: jobStatus.FAILED,
      };
    default:
      return state;
  }
};
